import { render, staticRenderFns } from "./pc.vue?vue&type=template&id=be434690&scoped=true&"
import script from "./pc.vue?vue&type=script&lang=ts&"
export * from "./pc.vue?vue&type=script&lang=ts&"
import style0 from "./pc.vue?vue&type=style&index=0&id=be434690&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be434690",
  null
  
)

export default component.exports